import classNames from 'classnames';
import React, { forwardRef } from 'react';
import Tooltip from '../Tooltip/Tooltip';

const BaseButton = forwardRef((props, ref) => {
	const { dataTestId = 'button', text, prefixIcon, suffixIcon, onClick, btnClassName, disabled, tooltipText, btnType, addbtnClass, ...buttonProps } = props;

	const buttonClass = classNames('DS_button', btnType === 'UTILITY' ? 'DS__button-utility-wrapper' : 'button-wrapper', btnClassName, addbtnClass, {
		'DS_button--disabled': disabled
	});

	return (
		<div
			className={buttonClass}
			data-testid={dataTestId}
			onClick={(e) => {
				if (!disabled && onClick) {
					onClick(e);
				}
			}}
		>
			<button
				ref={ref} // Pass the ref to the button element
				disabled={disabled}
				{...buttonProps}
				type="button"
			>
				{prefixIcon && <span className="prefix-icon">{prefixIcon}</span>}
				{text && (
					<Tooltip id={tooltipText ?? ''} content={tooltipText ?? ''} disabled={!tooltipText}>
						<span className="button-text">{text}</span>
					</Tooltip>
				)}
				{suffixIcon && <span className="suffix-icon">{suffixIcon}</span>}
			</button>
		</div>
	);
});

BaseButton.displayName = 'BaseButton';

export default BaseButton;
